export default "__VITE_ASSET__daab0f43__"